<template>
  <ValidationObserver
    v-slot="{ failed }"
    :class="{ updated }"
    class="updateable"
    tag="tr"
  >

    <td>
      <select v-if="isEditing" v-model="form.adTypeId">
        <option v-for="adType in adTypes" :key="adType.id" :value="adType.id">
          {{ adType.name }} ({{adType.price}} €)
        </option>
      </select>
      <div v-else class="bold MediaTypeRow__title">
        {{ adType.name }}
      </div>
    </td>

    <td>
      <ValidationProvider rules="required" v-slot="{ failed }">
        <TimeButton
          v-model="form.dayTimes"
          :error="failed"
          :readOnly="!isEditing"
        />
      </ValidationProvider>
    </td>

    <td>
      <ValidationProvider rules="required" v-slot="{ failed }">
        <PlaceButton
          v-model="form.locationIds"
          :error="failed"
          :readOnly="!isEditing"
        />
      </ValidationProvider>
    </td>
    <td>
      <span
        class="bold alignLower"
        :class="{
          'validate-warn':
            isEditing && isNotEnoughtMoney(campaign.computedPrice, team.money),
        }"
      >
        {{
            getCurrentPrice() | numbersThousands | inCurrency
        }}
        <br /><small
          v-if="
            isEditing && isNotEnoughtMoney(campaign.computedPrice, team.money)
          "
          >(Low budget)</small
        >
      </span>
      <div class="buttons">
        <template v-if="isTemp">
          <button
            v-if="isTemp"
            :class="{ disabled: failed || campaign.computedPrice > team.money }"
            class="confirmButton"
            title="Confirm"
            @click="saveCampaign()"
          >
            Confirm
          </button>
          <button
            v-if="!campaign.isTemp"
            class="confirmButton"
            @click="cancelEditing"
            title="Cancel"
          >
            Cancel
          </button>
        </template>
        <template v-else-if="isEditing">
          <button
            :class="{
              disabled:
                failed || isNotEnoughtMoney(campaign.computedPrice, team.money),
            }"
            class="confirmButton"
            title="Confirm"
            @click="saveCampaign()"
          >
            Confirm
          </button>
          <button class="cancelButton" @click="cancelEditing" title="Cancel">
            Cancel
          </button>
        </template>
        <button
          v-else-if="!archive"
          class="editButton"
          @click="editCampaign"
          :title="
            editing
              ? $t('messages.campaign.editing-locked-while-editing')
              : 'Edit'
          "
          :disabled="editing"
        >
          Edit
        </button>

        <button
          class="deleteButton"
          v-if="!archive"
          @click="deleteCampaign"
          :disabled="
            editing && (campaign.isTemp == undefined || !campaign.isTemp)
          "
          :title="
            editing && (campaign.isTemp == undefined || !campaign.isTemp)
              ? $t('messages.campaign.editing-locked-while-editing')
              : 'Delete'
          "
        >
          Delete
        </button>
        <button
          class="duplicateButton"
          :title="
            editing
              ? $t('messages.campaign.editing-locked-while-editing')
              : 'Duplicate'
          "
          @click="duplicateCampaign"
        >
          Duplicate
        </button>
      </div>
      <div class="campaignLock">
        <div :class="displayLock()"></div>
      </div>

      <Modal ref="modalRef" width="450px">
        <div>
          <div class="modal__questionHeader --smaller">
            <p style="margin-bottom: 0">
              Do you really want to purchase this campaign?
            </p>
            <p style="margin-top: 0.5rem">
              <small>
                You won't be able to edit it afterwards.
                <label class="block" style="padding-top: 1.5rem">
                  <input type="checkbox" v-model="hideCampaignReminder" />
                  <span class="checkmark"></span>
                  Don't show this again
                </label>
              </small>
            </p>
          </div>
        </div>
        <div class="clearfix">
          <button class="modal__approve" @click="saveCampaign">Yes</button>
          <div class="modal__cancel" @click="closeModal">Not yet</div>
        </div>
      </Modal>
    </td>
  </ValidationObserver>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import updatableMixin from "../../../mixins/updatableMixin";
import ModalJs from "@/components/general/ModalJs.js";
import TimeButton from "@/components/game/table/TimeButton.vue";
import PlaceButton from "@/components/game/table/PlaceButton.vue";

export default {
  name: "MediatypeRow",
  mixins: [updatableMixin, ModalJs],
  props: {
    campaign: Object,
    archive: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    TimeButton,
    PlaceButton,
  },
  data: function () {
    return {
      editMode: false,
      editCampaignBasePrice: 0,
      pricePerAd: 0,
      campaignVersion: 0,
      campaignLocations: 0,
      campaignHours: 0,
      lockIcon: true,
      editCampaignStartAds: 0,
      hideCampaignReminder:
        JSON.parse(localStorage.getItem("hideCampaignReminder")) || false,
      form: this.createForm(),
    };
  },
  computed: {
    ...mapGetters({
      adTypes: "gameAdTypes",
      team: "gameTeam",
      me: "me",
      game: "activeGame",
    }),
    isEditing() {
      return this.campaign.isTemp || this.editMode;
    },
    isTemp() {
      return this.campaign.isTemp;
    },
    adType() {
      return this.adTypes.find(
        (adType) => adType.id === this.form.adTypeId
      );
    },
  },
  methods: {
    createForm() {
      return { ...this.campaign };
    },
    async deleteCampaign() {
      this.$emit("finishEditing");
      if (this.checkLock()) {
        await this.$store.dispatch("deleteCampaign", this.campaign);
      } else {
        this.$toast.error(this.$t("messages.campaign.locked-challenge"));
      }
    },
    isNotEnoughtMoney(price, temaMoney) {
      if (price > temaMoney + this.editCampaignBasePrice) {
        return true;
      }
      return false;
    },
    async editCampaign() {
      if (this.checkLock()) {
        this.lockIcon = true;
        this.editCampaignBasePrice = this.campaign.computedPrice;
        this.editCampaignStartAds =
          this.campaign.locationIds.length * this.campaign.dayTimes.length;
          this.pricePerAd = this.editCampaignBasePrice/this.campaign.adCount;
        this.campaignVersion = this.campaign.version;
        this.campaignHours = this.campaign.dayTimes;
        this.campaignLocations = this.campaign.locationIds;
        this.form.locationIds = this.campaign.locationIds;
        this.form.dayTimes = this.campaign.dayTimes;
        this.editMode = true;
        await this.$store.dispatch("lockCampaign", this.campaign.id);
      } else {
        this.$toast.error(this.$t("messages.campaign.locked-challenge"));
      }
    },
    async saveCampaign() {
      if (!this.campaign.isTemp && _.isEqual(this.form, this.campaign)) {
          this.editMode = false
          return
        }
      if (this.form.locationIds.length > 0) {
        if (this.form.dayTimes.length > 0) {
          if (this.checkLock()) {
            var actualNumberAds =
              this.form.locationIds.length * this.form.dayTimes.length;
            var newCountAds = actualNumberAds - this.editCampaignStartAds;
            var adlimit = true;
            if (this.adLimitActive()) {
              if (this.getCurrentAds() + newCountAds > this.getMaximumAds()) {
                adlimit = false;
              }
            }
            this.lockIcon = false;
            if (adlimit) {
              this.$emit("finishEditing");
              await this.$store.dispatch("saveCampaign", {
                ...this.form,
                ...(this.campaign.isTemp ? { productId: this.productId } : {}),
              });
              this.editMode = false;
              this.form.version++;
            } else {
              this.$toast.error(this.$t("messages.campaign.max-ads-limit"));
            }
          } else {
            this.$toast.error(this.$t("messages.campaign.locked-challenge"));
          }
        } else {
          this.$toast.error(this.$t("messages.campaign.no-selected-time"));
        }
      } else {
        this.$toast.error(this.$t("messages.campaign.no-selected-place"));
      }
    },
    async saveEditedCampaign() {
      this.lockIcon = false;
      if (!this.campaign.isTemp && _.isEqual(this.form, this.campaign)) {
        this.editMode = false;
        await this.$store.dispatch("unlockCampaign", this.campaign.id);
        return;
      }
      await this.$store.dispatch("saveCampaign", {
        ...this.form,
        ...(this.campaign.isTemp ? { productId: this.productId } : {}),
      });
      await this.$store.dispatch("unlockCampaign", this.campaign.id);
      await this.$store.dispatch("fetchCampaigns");

      this.editMode = false;
    },
    async cancelEditing() {
      await this.$store.dispatch("unlockCampaign", this.campaign.id);
      this.lockIcon = false;
      this.editMode = false;
      this.form = this.createForm();
      this.form.locationIds = this.campaign.locationIds;
      this.form.dayTimes = this.campaign.dayTimes;
      await this.$store.dispatch("fetchCampaigns");
    },
    duplicateCampaign() {
      this.$store.dispatch("duplicateCampaign", this.campaign);
      if (this.archive) {
        this.$emit("showNewCampaigns");
      }
      if (this.$router.currentRoute.path != "/game/SetCampaigns") {
        this.$router.push("/game/SetCampaigns");
      }
    },
    displayLock() {
      if (this.campaign.lockUser != null) {
        if (this.campaign.lockUser.id == this.me.id) {
          return "lockImage-green";
        }
        return "lockImage-red";
      }
      this.form.locationIds = this.campaign.locationIds;
      this.form.dayTimes = this.campaign.dayTimes;
    },
    checkLock() {
      if (this.campaign.lockUser != null) {
        if (this.campaign.lockUser.id == this.me.id) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    getMaximumAds() {
      if (this.game != null) {
        if (this.game.adLimitPerTurn != null) {
          return this.game.adLimitPerTurn;
        } else {
          return 0;
        }
      }
    },
    adLimitActive() {
      if (this.game != null) {
        if (this.game.adLimitPerTurn != null && this.game.adLimitPerTurn > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    getCurrentAds() {
      if (this.team != null) {
        var pocet = this.team.adCountCurrentTurn;
        return pocet;
      }
      return 0;
    },
    getCurrentPrice(){
      if(this.editMode){
       /* if(this.form.locationIds.length == 0 || this.form.dayTimes.length == 0 || this.pricePerAd){
          console.log("Je tam něaká nula")
          return 0;
        }*/
        let priceAdType = this.adType.price;
        return this.form.locationIds.length*this.form.dayTimes.length*priceAdType;

      }else if(this.campaign.archived == true){
        return this.campaign.price
      }else{
        return this.campaign.computedPrice || this.form.computedPrice
      }
    }
  },
  watch: {
    // tohle jsem odebral při řešení issue s měněním pořadí při vybírání, nevidím důvod aby se updatoval store při změně něčeho ve formu, od toho je tlačítko confirm ne?
    form: {
      deep: true,
      handler(value) {
        if (!this.editMode) this.$store.dispatch("updateCampaign", value);
      },
    },
    hideCampaignReminder(value) {
      localStorage.setItem("hideCampaignReminder", value);
    },
    isEditing() {
      if (!this.isEditing) {
        this.$emit("finishEditing");
      }
      if (this.isEditing) {
        this.$emit("editing");
      }
    },
  },
  mounted() {
    if (this.isEditing) {
      this.$emit("editing");
    }
  },
};
</script>
